import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _getIterator from "@babel/runtime-corejs3/core-js/get-iterator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _matchAllInstanceProperty from "@babel/runtime-corejs3/core-js/instance/match-all";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";

// Create a React Context with the given name.
var createNamedContext = function createNamedContext(name, defaultValue) {
  var Ctx = React.createContext(defaultValue);
  Ctx.displayName = name;
  return Ctx;
}; // Separator token used during param type recognition.


var separator = '__redwood_param_type__'; // Convert the given path (from the path specified in the Route) into a regular
// expression that will match any named parameters. Param types are handled here
// as well.
//
// path          - The path as specified in the <Route ... />.
// allParamTypes - The object containing all param type definitions.
//
// Examples:
//
//   reRoute('/blog/{year}/{month}/{day}', { ... })
//   reRoute('/post/{id:Int}', { Int: { ... }})

var reRoute = function reRoute(path, allParamTypes) {
  var _context;

  var pathWithCaptures = path;

  _forEachInstanceProperty(_context = _Object$keys(allParamTypes)).call(_context, function (pType) {
    var _context2, _context3;

    var pConstraint = allParamTypes[pType].constraint;
    var regex = new RegExp("{([^}]+):".concat(pType, "}"), 'g');
    var constraintString = pConstraint.toString();
    var constraint = constraintString.substring(1, constraintString.length - 1);

    var capture = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "(?<$1".concat(separator)).call(_context3, pType, ">")).call(_context2, constraint, ")");

    pathWithCaptures = pathWithCaptures.replace(regex, capture);
  });

  pathWithCaptures = pathWithCaptures.replace(/\{([^}]+)\}/g, '(?<$1>[^/]+)');
  return "^".concat(pathWithCaptures, "$");
}; // Determine if the given route is a match for the given pathname. If so,
// extract any named params and return them in an object.
//
// route         - The route path as specified in the <Route path={...} />
// pathname      - The pathname from the window.location.
// allParamTypes - The object containing all param type definitions.
//
// Examples:
//
//   matchPath('/blog/{year}/{month}/{day}', '/blog/2019/12/07')
//   => { match: true, params: { year: '2019', month: '12', day: '07' }}
//
//   matchPath('/about', '/')
//   => { match: false }
//
//   matchPath('/post/{id:Int}', '/post/7')
//   => { match: true, params: { id: 7 }}


var matchPath = function matchPath(route, pathname, allParamTypes) {
  var matches = _Array$from(_matchAllInstanceProperty(pathname).call(pathname, reRoute(route, allParamTypes)));

  if (matches.length > 0) {
    var _context4;

    var params = matches[0].groups || {}; // Handle param types.

    var transformedParams = _reduceInstanceProperty(_context4 = _Object$keys(params)).call(_context4, function (acc, key) {
      var pMatches = key.match("^(\\w+)".concat(separator, "(\\w+)$"));

      if (pMatches && pMatches.length > 0) {
        var _pMatches = _slicedToArray(pMatches, 3),
            _ = _pMatches[0],
            pName = _pMatches[1],
            pType = _pMatches[2];

        acc[pName] = allParamTypes[pType].transform(params[key]);
      } else {
        acc[key] = params[key];
      }

      return acc;
    }, {});

    return {
      match: true,
      params: transformedParams
    };
  } else {
    return {
      match: false
    };
  }
}; // Parse the given search string into key/value pairs and return them in an
// object.
//
// Examples:
//
//   parseSearch('?key1=val1&key2=val2')
//   => { key1: 'val1', key2: 'val2' }


var parseSearch = function parseSearch(search) {
  if (search === '') {
    return {};
  }

  var searchPart = search.substring(1);
  var pairs = searchPart.split('&');
  var searchProps = {};

  _forEachInstanceProperty(pairs).call(pairs, function (pair) {
    var keyval = pair.split('=');
    searchProps[keyval[0]] = keyval[1] || '';
  });

  return searchProps;
}; // Validate a path to make sure it follows the router's rules. If any problems
// are found, a descriptive Error will be thrown, as problems with routes are
// critical enough to be considered fatal.


var validatePath = function validatePath(path) {
  // Check that path begins with a slash.
  if (path[0] !== '/') {
    throw new Error('Route path does not begin with a slash: "' + path + '"');
  } // Check for duplicate named params.


  var matches = _matchAllInstanceProperty(path).call(path, /\{([^}]+)\}/g);

  var memo = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _getIterator(matches), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var match = _step.value;
      var param = match[0];

      if (memo[param]) {
        throw new Error('Route path contains duplicate parameter: "' + path + '"');
      } else {
        memo[match[0]] = true;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
}; // Take a given route path and replace any named parameters with those in the
// given args object. Any extra params not used in the path will be appended
// as key=value pairs in the search part.
//
// Examples:
//     replaceParams('/tags/{tag}', { tag: 'code', extra: 'foo' })
//     => '/tags/code?extra=foo


var replaceParams = function replaceParams(path) {
  var _context5;

  var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // Split the path apart and replace named parameters with those sent in,
  // then join it back together.
  var parts = path.split('/');

  var newPath = _mapInstanceProperty(parts).call(parts, function (part) {
    if (part[0] === '{' && part[part.length - 1] === '}') {
      var paramSpec = part.substr(1, part.length - 2);
      var paramName = paramSpec.split(':')[0];
      var arg = args[paramName];

      if (arg) {
        delete args[paramName];
        return arg;
      }
    }

    return part;
  }).join('/'); // Prepare any unnamed params to be be appended as search params.


  var queryParams = [];

  _forEachInstanceProperty(_context5 = _Object$keys(args)).call(_context5, function (key) {
    var _context6;

    queryParams.push(_concatInstanceProperty(_context6 = "".concat(key, "=")).call(_context6, args[key]));
  }); // Append any unnamed params as search params.


  if (queryParams.length) {
    newPath += "?".concat(queryParams.join('&'));
  }

  return newPath;
};

export { createNamedContext, reRoute, matchPath, parseSearch, validatePath, replaceParams };